import React, { useRef, useState } from "react";
import { findBonByBarcode } from "../../../_App/Redux/Slices/reduction/reductionSlice";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { setReduction } from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import { useAppDispatch } from "../../../_App/Redux/hooks";

const BonReductionMethod = ( {cart}:any) => {
    const dispatch = useAppDispatch();
  
const lastKeyTime = useRef(0);
const timerRef = useRef<any>(null);

const handleInputChange = (value: string) => {
  const now = Date.now();

  const delta = now - lastKeyTime.current;
  lastKeyTime.current = now;

  clearTimeout(timerRef.current);

  if (delta < 50) {
    timerRef.current = setTimeout(() => {
      handleFindBon(value);
    }, 100); 
  } else {
    timerRef.current = setTimeout(() => {
      handleFindBon(value);
    }, 2000);
  }
};
  const handleFindBon = async (code: string) => {
    const resp = await dispatch(findBonByBarcode(code));
    const bonsReduction = resp.payload;
    const today = new Date();

    if (bonsReduction && bonsReduction) {
      const expireDate = new Date(bonsReduction.dateEcheance);

      const expireDateLocal = new Date(
        expireDate.getTime() + expireDate.getTimezoneOffset() * 60000
      );
      if (expireDateLocal < today) {
        ToastWarning("Ce bon de réduction est expiré !");
      } else {
        if (!bonsReduction.valide) {
          ToastWarning("Ce bon est déjà utilisé!");
        } else {
          if (cart.Bons.some((item: any) => item._id === bonsReduction._id)) {
            ToastWarning("Ce bon est déjà selectionné !");
          } else {
            dispatch(
              setReduction({
                amount: Number(bonsReduction.amount.toFixed(3)),
                bon: bonsReduction,
              })
            );
          }
        }
      }
    } else {
      ToastWarning("Bon de réduction introuvable !");
    }
  };
  return (
    <div>
      <div className="navbar-item flex-row search-ul navbar-dropdown">
        <div className="nav-item align-self-center search-animated">
          <form
            className="form-inline search-full form-inline search"
            role="search"
          >
            <div className="search-bar" style={{ marginBottom: "7px" }}>
              <div className="relative w-full">
                <input
                  type="text"
                  className="form-control search-form-control ml-lg-auto pr-16"
                  placeholder="Code Bon"
                  onChange={(e) => handleInputChange(e.currentTarget.value)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BonReductionMethod;
